export const getSelectedDateSpan = () => {
	return localStorage.getItem(`selectedDateSpan`) || 'week';
};
export const setSelectedDateSpan = (selectedDateSpan) => {
	return localStorage.setItem(`selectedDateSpan`, selectedDateSpan);
};
